import ShortStopDetailsModal from './ShortStopDetailsModal';

export default ShortStopDetailsModal;
